import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=588fa5ce&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=js&"
export * from "./videoList.vue?vue&type=script&lang=js&"
import style0 from "./videoList.vue?vue&type=style&index=0&id=588fa5ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fa5ce",
  null
  
)

export default component.exports